import * as firebase from 'firebase';
import {
  loginUserFromFirebase,
  logoutUserFromFirebase,
  getUserFromFirebase,
  addUserToFirebase,
  updateUserToFirebase,
  importUsersToFirebase,
  updateUsersBalanceToFirebase,
  getUsersDataFromFirebase,
  getSingleUserFromFirebase,
  deleteUserFromFirebase,
  searchUserFromFirebase,
  checkUserRole
} from '../utils/userService';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';

export const USER_FROM_TOKEN = 'USER_FROM_TOKEN';
export const USER_FROM_TOKEN_SUCCESS = 'USER_FROM_TOKEN_SUCCESS';
export const USER_FROM_TOKEN_FAILURE = 'USER_FROM_TOKEN_FAILURE';

export const ADD_USER = 'ADD_USER';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const SEARCH_USER = 'SEARCH_USER';
export const SEARCH_USER_SUCCESS = 'SEARCH_USER_SUCCESS';
export const SEARCH_USER_FAILURE = 'SEARCH_USER_FAILURE';

export const IMPORT_USERS = 'IMPORT_USERS';
export const IMPORT_USERS_SUCCESS = 'IMPORT_USERS_SUCCESS';
export const IMPORT_USERS_FAILURE = 'IMPORT_USERS_FAILURE';

export const UPDATE_USERS_BALANCE = 'UPDATE_USERS_BALANCE';
export const UPDATE_USERS_BALANCE_SUCCESS = 'UPDATE_USERS_BALANCE_SUCCESS';
export const UPDATE_USERS_BALANCE_FAILURE = 'UPDATE_USERS_BALANCE_FAILURE';

export const GET_USERS_DATA = 'GET_USERS_DATA';
export const GET_USERS_DATA_SUCCESS = 'GET_USERS_DATA_SUCCESS';
export const GET_USERS_DATA_FAILURE = 'GET_USERS_DATA_FAILURE';

export const GET_SINGLE_USER = 'GET_SINGLE_USER';
export const GET_SINGLE_USER_SUCCESS = 'GET_SINGLE_USER_SUCCESS';
export const GET_SINGLE_USER_FAILURE = 'GET_SINGLE_USER_FAILURE';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';

export function loginUser({ email = null, password = null }){
  return async (dispatch) => {
    dispatch({ type: LOGIN_USER });
    try {
      const user = await loginUserFromFirebase({ email, password });
      const role = await checkUserRole(user.uid);
      localStorage.setItem('jwtToken', await user.getIdToken(true));
      return dispatch({ type: LOGIN_USER_SUCCESS, payload: { user: user, role: role } });
    } catch (e) {
      console.log(e);
      localStorage.removeItem('jwtToken');
      await firebase.auth().signOut();
      return dispatch({ type: LOGIN_USER_FAILURE, payload: { error: e } });
    }
  }
}

export function getAuthUser(){
  return async (dispatch) => {
    dispatch({ type: USER_FROM_TOKEN });
    try {
      const user = await getUserFromFirebase();
      const role = await checkUserRole(user.uid);
      localStorage.setItem('jwtToken', await user.getIdToken(true));

      return dispatch({ type: USER_FROM_TOKEN_SUCCESS,  payload: { user: user, role: role } });
    } catch (e) {
      localStorage.removeItem('jwtToken');
      return dispatch({ type: USER_FROM_TOKEN_FAILURE, payload: { error: e } })
    }
  }
}

export function logoutUser(){
  return async (dispatch) => {
    dispatch({ type: LOGOUT_USER });
    try {
      localStorage.removeItem('jwtToken');
      await logoutUserFromFirebase();
      return dispatch({ type: LOGOUT_USER_SUCCESS, payload: null })
    } catch(e) {
      return dispatch({ type: LOGOUT_USER_FAILURE, payload: { error: e } })
    }
  } 
}

export function addUser({ email = '', password = '', name = '', username = '', active = '', ...rest }){
  return async (dispatch) => {
    dispatch({ type: ADD_USER })
    try {
      const token = localStorage.getItem('jwtToken');
      const { data } = await addUserToFirebase({ token, email, password, name, username, active, ...rest });
      return dispatch({ type: ADD_USER_SUCCESS, payload: { user : data } });
    } catch ({ response: { data, status } }) {
      return dispatch({ type: ADD_USER_FAILURE, payload: { error: { data, status } } })
    }
  }
}

export function updateUser({ userData, username }){
  return async (dispatch) => {
    dispatch({ type: UPDATE_USER })
    try {
      const token = localStorage.getItem('jwtToken');
      const { data } = await updateUserToFirebase({token, data: userData, username});
      return dispatch({ type: UPDATE_USER_SUCCESS, payload: { user : data.user } });
    } catch ({ response: { data, status } }) {
      return dispatch({ type: UPDATE_USER_FAILURE, payload: { error: { data, status } } })
    }
  }
}

export function importUsersFromCsv(fileData) {
  return async (dispatch) => {
    dispatch({ type: IMPORT_USERS })
    try {
      const token = localStorage.getItem('jwtToken');
      const { data } = await importUsersToFirebase({ token, data: fileData });
      return dispatch({ type: IMPORT_USERS_SUCCESS, payload: { log: data }});
    } catch ({ response: { data, status } }) {
      return dispatch({ type: IMPORT_USERS_FAILURE, payload: { error: { data, status } } })
    }
  }
}

export function updateUsersBalanceFromCsv(fileData) {
  return async (dispatch) => {
    dispatch({ type: UPDATE_USERS_BALANCE })
    try {
      const token = localStorage.getItem('jwtToken');
      const { data } = await updateUsersBalanceToFirebase({ token, data: fileData });
      return dispatch({ type: UPDATE_USERS_BALANCE_SUCCESS, payload: { log: data }});
    } catch ({ response: { data, status } }) {
      return dispatch({ type: UPDATE_USERS_BALANCE_FAILURE, payload: { error: { data, status } } })
    }
  }
}

export function getUsersData({ page, limit }){
  return async (dispatch) => {
    dispatch({type: GET_USERS_DATA})
    try {
      const token = localStorage.getItem('jwtToken');
      const { data } = await getUsersDataFromFirebase({ token, page, limit });
      return dispatch({ type: GET_USERS_DATA_SUCCESS, payload: { data: data.data } })
    } catch ({ response: { data, status } }) {
      return dispatch({type: GET_USERS_DATA_FAILURE, payload: { error: { data, status } } })
    }
  }
}

export function getSingleUser({ username }){
  return async (dispatch) => {
    dispatch({type: GET_SINGLE_USER})
    try {
      const token = localStorage.getItem('jwtToken');
      const { data } = await getSingleUserFromFirebase({ token, username });
      return dispatch({ type: GET_SINGLE_USER_SUCCESS, payload: { data: data } })
    } catch ({ response: { data, status } }) {
      return dispatch({type: GET_SINGLE_USER_FAILURE, payload: { error: { data, status } } })
    }
  }
}

export function deleteUser({ username }){
  return async (dispatch) => {
    dispatch({ type: DELETE_USER })
    try {
      const token = localStorage.getItem('jwtToken');
      const { data } = await deleteUserFromFirebase({ token, username });
      return dispatch({ type: DELETE_USER_SUCCESS, payload: { uid: data.user } });
    } catch ({ response: { data, status } }) {
      return dispatch({ type: DELETE_USER_FAILURE, payload: { error: {data, status} } });
    }
  }
}

export function searchUser({ query }){
  return async (dispatch) => {
    dispatch({ type: SEARCH_USER })
    try {
      const token = localStorage.getItem('jwtToken');
      const { data } = await searchUserFromFirebase({ token, query });
      return dispatch({ type: SEARCH_USER_SUCCESS, payload: { users: data.users } });
    } catch ({ response: { data, status } }) {
      return dispatch({ type: SEARCH_USER_FAILURE, payload: { error: { data, status } } });
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js